export const getSubdomain = () => {
  const hostname = window.location.hostname
  const parts = hostname.split('.')

  if (parts.length > 2 && parts[0] !== 'www' && parts[0].length === 5) {
    return parts[0]
  }

  return null
}
